<template>
    <div class="form-group" style="margin-top: 20px;">
        <label class="col-sm-2 control-label text-label">
            QA/QC Status:
        </label>
        <div class="col-sm-2 alert text-label" :class="qaqcAlertClass(sectionName)">{{qaqcProgressDto[sectionName] ? 'Completed' : 'Not Completed'}}</div>
        <div class="col-sm-1"></div>
        <div class="col-sm-2">
            <button class="btn btn-warning" v-on:click="qaqcMarkAll(1)">Replace All</button>
        </div>
        <div class="col-sm-2">
            <button class="btn btn-danger" v-on:click="qaqcMarkAll(2)">Ignore All</button>
        </div>
        <div class="col-sm-2">
            <button class="btn btn-default" v-on:click="qaqcMarkAll(3)">Append All</button>
        </div>
        <div class="col-sm-2">
            <button class="btn btn-primary" v-on:click="completeSection(sectionName)">Complete Section</button>
        </div>
    </div>
</template>

<script>
import loggingService from '../../services/util/loggingService'
import qaqcService from '../../services/qaqcService'

export default {
    name: 'qaqcFormFieldFooter',
    props: {
        qaqcProgressDto: { default: () => {} },
        qaqcSelection: { default: () => {} },
        sectionName: { default: '' },
        completeSection: { default: () => { return } }
    },
    data: function () {
        return {
            isDebug: false
        }
    },
    mounted () {
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'Qaqc Select Form', message)
        },
        //method to add appropriate alert class to QA/QC status.  This is passed to child component forms
        qaqcAlertClass (fieldName) {
            return this.qaqcProgressDto[fieldName] ? 'alert-success' : 'alert-danger'
        },
        qaqcMarkAll (selectionNumber) {
            if (selectionNumber === 3) {
                //get parent's component (form) and filter its child components for 'qaqcSelectFormField'
                var qaqcSelectComp = this.$parent.$children.filter(x => x.$options && x.$options.name === 'qaqcSelectFormField')
                //if qaqcSelect component has 'hasAppend', mark that field's QA/QC selection to Append
                qaqcSelectComp.forEach(qsc => {
                    if (qsc.hasAppend && !!qsc.fieldName && (qsc.fieldName in this.qaqcSelection)) {
                        this.qaqcSelection[qsc.fieldName] = selectionNumber
                    }
                })
            } else {
                for (let key in this.qaqcSelection) {
                    let excludedKeys = qaqcService.excludedKeys
                    if (!excludedKeys.includes(String(key))) {
                        this.qaqcSelection[key] = selectionNumber
                    }
                }
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// QaqcFormFieldFooter.vue?6be16afc